<template>
  <div v-if="quoteSummary != null" class="modal-content !w-[550px] !rounded-[20px] mx-auto ">
    <div class="modal-body p-4">
      <div class="flex flex-col gap-3">
        <div class="flex items-center justify-between">
          <div v-if="Object.keys(quoteDetail).length > 0" class="flex items-center gap-2">
            <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
            <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
            <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Quote Summary</h2>
          </div>
          <button type="button" @click="closeModal" class="w-[40px] h-[40px] p-2 bg-[#fff]">
            <img src="@/assets/images/modal-cross-icon.png" class="w-full h-full">
          </button>
        </div>
        <div class="flex items-center justify-between">
          <h3 class="m-0 text-[16px] font-lato font-bold text-[#333333]">Items Added</h3>
          <h2 class="m-0 text-[40px] font-lato font-bold text-[#092E87]">
            ${{ $helper.formatAmountMode(quoteSummary.item_total, 1) }}.<span class="text-[25px]">{{
              $helper.formatAmountMode(quoteSummary.item_total, 2) }}</span>
          </h2>
        </div>
        <div v-if="quoteSummary.items.length > 0" class="!pe-2 max-h-[50vh] overflow-y-auto overflow-hidden [scrollbar-width:thin] 
                [scrollbar-color:#ff5b00_#f3f3f3]
                [&&::-webkit-scrollbar]:w-[6px]
                [&&::-webkit-scrollbar-track]:bg-[#f3f3f3]
                [&&::-webkit-scrollbar-track]:!rounded-full
                [&&::-webkit-scrollbar-thumb]:bg-[#ff5b00]
                [&&::-webkit-scrollbar-thumb]:!rounded-full
                [&&::-webkit-scrollbar-thumb:hover]:bg-[#e94d00]
                [&&::-webkit-scrollbar-button]:!hidden">
          <ul class="p-0 m-0 flex flex-col gap-2">
            <li v-for="(item, index) in quoteSummary.items[0].data" :key="index"
              class="flex items-center justify-between border-1 p-2 rounded-[5px] bg-opacity-50 bg-[#EFEFEF] border-[#EFEFEF]">
              <span class="text-[14px] font-semibold leading-[1.2] font-lato text-[#092E87]">{{ item.option }}:
                <p v-if="item.sub_text?.length > 0" class="m-0 text-[12px] font-normal font-lato text-[#333333]">({{ item.sub_text
                }})
                </p>
              </span>
              <span v-if="item.total_cost < 0" class="text-[20px] font-lato font-medium text-[#333333]">
                $({{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{ $helper.formatAmountMode(item.total_cost, 2)
                }}</span>)
              </span>
              <span v-else class="text-[20px] font-lato font-medium text-[#333333]">
                ${{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{ $helper.formatAmountMode(item.total_cost, 2)
                }}</span>
              </span>
            </li>
          </ul>
          <div v-if="quoteSummary.items.length > 2">
            <div v-for="(item, index) in quoteSummary.items[2].data" :key="index"
              class="flex items-center justify-between mt-2 border-1 p-2 rounded-[5px] bg-[#fff] border-[#EFEFEF]">
              <span v-if="quoteDetail.partner_info.is_allied" class="text-[16px] font-lato text-[#333333]">
                {{ quoteSummary.items[2].data[0].option }}
              </span>
              <span v-else class="text-[16px] font-lato text-[#333333]">
                {{ quoteSummary.items[2].heading }}
              </span>
              <h2 v-if="item.total_cost < 0" class="m-0 text-[20px] font-lato font-medium text-[#FE5000]">
                $({{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{ $helper.formatAmountMode(item.total_cost,
                  2)
                  }}</span>)
              </h2>
              <h2 v-else class="m-0 text-[20px] font-lato font-medium text-[#FE5000]">
                ${{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{ $helper.formatAmountMode(item.total_cost,
                  2)
                  }}</span>
              </h2>
            </div>
            <!-- <ul class="p-0 m-0 flex flex-col">
              <li v-for="(item, index) in quoteSummary.items[2].data" :key="index">
                <span>{{ item.option }} :
                </span>
                <span v-if="item.total_cost < 0">${{ $helper.formatAmountMode(item.total_cost,1)}}.<small>{{
                    $helper.formatAmountMode(item.total_cost,2) }}</small></span>
                <span v-else>${{ $helper.formatAmountMode(item.total_cost,1)}}.<small>{{
                    $helper.formatAmountMode(item.total_cost,2) }}</small></span>    
              </li>
            </ul> -->
          </div>
          <div v-if="quoteSummary.items.length > 1">
            <div v-for="(item, index) in quoteSummary.items[1].data" :key="index"
              class="flex items-center justify-between border-1 p-2 mt-2 rounded-[5px] bg-[#fff] border-[#EFEFEF]">
              <span v-if="quoteDetail.partner_info.company_name.toLowerCase() == 'vivint'"
                class="text-[16px] font-lato text-[#333333]">
                Vivint Coverage
              </span>
              <span v-if="quoteDetail.partner_info.is_allied" class="text-[14px] font-lato text-[#333333]">
                {{ quoteSummary.items[1].data[0].option }}
              </span>
              <span v-else class="text-[14px] font-lato text-[#333333]">
                {{ quoteSummary.items[1].heading }}
              </span>
              <h2 v-if="item.total_cost < 0" class="m-0 text-[20px] font-lato font-medium text-[#FE5000]">
                $({{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{ $helper.formatAmountMode(item.total_cost,
                  2)
                  }}</span>)
              </h2>
              <h2 v-else class="m-0 text-[16px] font-lato font-medium text-[#FE5000]">
                ${{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{ $helper.formatAmountMode(item.total_cost,
                  2)
                  }}</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-between">
          <h3 class="m-0 text-[16px] font-lato text-[#092E87]">Quote Total:</h3>
          <h2 class="m-0 text-[40px] font-lato font-bold text-[#333333]">
            ${{ $helper.formatAmountMode(quoteSummary.total, 1) }}.<span class="text-[25px]">{{
              $helper.formatAmountMode(quoteSummary.total, 2)
              }}</span>
          </h2>
        </div>
      </div>
      <!-- <dialog></dialog> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { enableScroll } from "../../helpers/scrollHelper";
export default {
  components: {},
  props: ["quoteSummary", "readOnly"],

  data() {
    return {};
  },
  computed: {
    ...mapGetters(["quoteDetail"]),
  },
  watch: {},
  mounted() { },
  methods: {
    ...mapActions(["setCommponent"]),
    editQuoteClicked() {
      this.setCommponent("QuoteItems");
    },
    closeModal() {
      document.documentElement.style.overflow = '';
      enableScroll()
      this.$emit("event", "close");
    },
  },
};
</script>
